import { Link } from 'react-router-dom';

import { Button } from '@/components/button';
import { Icon } from '@/components/icon';
import { Reveal } from '@/components/reveal';
import { Section } from '@/components/section';
import { projects } from '@/data/projects';

export function ProjectsTeaser(): React.ReactNode {
  return (
    <Section background="bone" spacing="loose">
      <Reveal>
        <div className="mb-10 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.3em] text-moss">
              Referenzen
            </p>
            <h2 className="font-display text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.05] tracking-tight">
              Echte Projekte. <br />
              <span className="text-mute">Echte Bäume.</span>
            </h2>
          </div>
          <Button as="link" to="/referenzen" variant="secondary">
            Alle Referenzen
            <Icon name="ArrowRight" className="h-4 w-4" />
          </Button>
        </div>
      </Reveal>

      {/* Edge-bleed: -mx + px so cards align with content max-width on first card */}
      <div className="-mx-5 sm:-mx-8">
        <ul
          className="flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 scroll-smooth [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:gap-6 sm:px-8"
          aria-label="Referenzprojekte"
        >
          {projects.map((project) => (
            <li
              key={project.id}
              className="shrink-0 snap-start basis-[78%] sm:basis-[44%] lg:basis-[30%]"
            >
              <Link
                to="/referenzen"
                className="group block h-full overflow-hidden rounded-lg border border-stone bg-paper transition-shadow hover:shadow-md"
              >
                <div className="overflow-hidden">
                  {project.image.includes('placeholder-') ? (
                    <div
                      className="flex aspect-[4/3] items-center justify-center bg-stone/60"
                      role="img"
                      aria-label={project.title}
                    >
                      <span className="text-xs italic text-mute/80">Platzhalter</span>
                    </div>
                  ) : (
                    <div
                      className="aspect-[4/3] bg-stone bg-cover bg-center transition-transform duration-500 group-hover:scale-[1.04]"
                      role="img"
                      aria-label={project.title}
                      style={{ backgroundImage: `url('${project.image}')` }}
                    />
                  )}
                </div>
                <div className="p-5">
                  <p className="text-xs uppercase tracking-[0.2em] text-mute">
                    {project.category} · {project.city} · {String(project.year)}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-semibold leading-tight tracking-tight">
                    {project.title}
                  </h3>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <p className="mt-4 flex items-center gap-2 text-xs text-mute sm:hidden">
        <Icon name="ArrowRight" className="h-3 w-3" />
        zum Durchwischen
      </p>
    </Section>
  );
}
